import { Alert, Button, Stack, Text } from '@mantine/core';
import { IconAlertTriangle, IconRefresh } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface TravelSettingsStaleAlertProps {
  isReloading: boolean;
  onReload: () => void;
}

export function TravelSettingsStaleAlert({ isReloading, onReload }: TravelSettingsStaleAlertProps) {
  const { t } = useTranslation();

  return (
    <Alert
      color="yellow"
      icon={<IconAlertTriangle size={18} />}
      title={t('notification.error.code.TRAVEL_SETTINGS_STALE')}
    >
      <Stack
        gap="xs"
        align="flex-start"
      >
        <Text size="sm">{t('travel.settings.stale.text')}</Text>
        <Button
          type="button"
          size="xs"
          variant="light"
          color="yellow"
          leftSection={<IconRefresh size={16} />}
          loading={isReloading}
          onClick={onReload}
        >
          {t('travel.settings.stale.reload')}
        </Button>
      </Stack>
    </Alert>
  );
}
